import { useState } from "react";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";

//BKARADENIZ;453138;02042025; Kan Şeker Takibi Formu Yapıldı
function BloodSugarTrace() {
  const [alertOpen, setAlertOpen] = useState(false);

  const { t } = useTranslate();

  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzNurseSaveButton />
        <ByzNurseDeleteButton />
        <ByzNursePrintButton2 />
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={6} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("blood-sugar-trace.title")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography pl={3} pt={0}>
                  {t("datetime")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker sx={{ width: "100%" }} />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>{t("createdby")}</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "100%" }}
                  disabled
                  label={t("createdby")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("blood-sugar-trace.create.blood-sugar")}
              </ByzMuiTypography>
            </Grid>
 
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.result(mg-dl)")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField sx={{ width: "100%" }} />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.a-hunger-t-satiety")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} pt={0}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[
                    { label: "A", value: 1 },
                    { label: "T", value: 2 },
                  ]}
                  sx={{ width: "100%" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.g-glucometri-l-lab-k-blood-gas")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} pt={0}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[
                    { label: "G", value: 1 },
                    { label: "L", value: 2 },
                    { label: "K", value: 3 },
                  ]}
                  sx={{ width: "100%" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("blood-sugar-trace.create.antidiabetic-treatments")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.drug-name")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[]}
                  sx={{ width: "100%" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.dose")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField sx={{ width: "100%" }} />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography isTitle>
                {t("blood-sugar-trace.create.apply")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.way")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[
                    { label: "IV", value: 1 },
                    { label: "SC", value: 2 },
                    { label: "PO", value: 3 },
                  ]}
                  sx={{ width: "100%" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography pl={3}>
                  {t("blood-sugar-trace.create.area")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField {...params} variant="outlined" />
                  )}
                  options={[
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                  ]}
                  sx={{ width: "100%" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={t("operation-successful")}
              message={t("operation-successful-message")}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default BloodSugarTrace;
